import Bignumber from 'bignumber.js';

export const isAllNumber = (num: unknown) =>
  /^[-]?[0-9]*[.,]?[0-9]+$/.test(String(num));

export const minus = (a: number, b: number, count: number = 2) =>
  toFixed(new Bignumber(a).minus(b).toNumber(), count);

export const plus = (a: number, b: number, count: number = 2) =>
  toFixed(new Bignumber(a).plus(b).toNumber(), count);

export const toFixed = (num: number, count: number = 2) => {
  return Number.isInteger(num)
    ? num
    : isAllNumber(num)
    ? new Bignumber(new Bignumber(num).toFixed(count)).toNumber()
    : null;
};

export const dividedBy = (a: number, b: number, count: number = 2) => {
  const num = new Bignumber(a).dividedBy(b).toNumber();
  return toFixed(num, count);
};

export const multipliedBy = (a: number, b: number, count: number = 2) => {
  const num = new Bignumber(a).multipliedBy(b).toNumber();
  return toFixed(num, count);
};

/** Конвертация километров в метры. */
export const convertFromKmToM = (value: number | null | undefined) => {
  const km = parseFloat(String(value));
  if (km >= 0) {
    return multipliedBy(km, 1000);
  }
  return value;
};

/** Конвертация метров в километры. */
export const convertFromMToKm = (value: number | null | undefined) => {
  const m = parseInt(String(value), 10);
  if (m >= 0) {
    return dividedBy(m, 1000, 3);
  }
  return value;
};

/** Конвертация копеек в рубли. */
export const convertFromKopToRub = (value: number | null | undefined) => {
  const kop = parseInt(String(value), 10);
  if (kop >= 0) {
    return dividedBy(kop, 100);
  }
  return value;
};

/** Конвертация рублей в копейки. */
export const convertFromRubToKop = (value: number | null | undefined) => {
  const rub = parseFloat(String(value));
  if (rub >= 0) {
    return multipliedBy(rub, 100);
  }
  return value;
};

/** Конвертация секунд в часы. */
export const convertFromSecondToHour = (value: number | null | undefined) => {
  const second = parseInt(String(value), 10);
  if (second >= 0) {
    return second / 3600;
  }
  return value;
};

/** Конвертация часов в секунды. */
export const convertFromHourToSecond = (value: number | null | undefined) => {
  const hour = parseFloat(String(value));
  if (hour >= 0) {
    return hour * 3600;
  }
  return value;
};
